import {
  ThemeProvider,
  Authenticator,
  useTheme,
  Image,
  View,
  Text
} from '@aws-amplify/ui-react';
import { useAuthenticator } from '@aws-amplify/ui-react';

// env var
const {
  NODE_ENV,
  REACT_APP_VERSION,
} = process.env;

const components = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View className='py-10 w-full flex flex-col'>
        <Image
          alt="App logo"
          src="/swifix-logo.png"
          height={'100%'}
        />

        <div className='py-4 h-[10vh] w-full flex flex-col justify-between items-center'>
          <Text className='text-base text-slate-700 font-bold uppercase'>Administrator</Text>
        </div>
      </View>
    );
  },
  Footer() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Text fontSize={12}>Version: {REACT_APP_VERSION} {NODE_ENV === 'development' ? 'Development' : null}</Text>
      </View>
    );
  }
};

const AuthenticatorComponent = ({ children }) => {

  // hooks
  const { route }  = useAuthenticator(context => [context.route]);
  console.log('providers.authentication.amplify@AuthenticatorComponent', 'route', route);

  return (
    <Authenticator
      components={components}
      hideSignUp
    >
      {route === 'authenticated' && children}
    </Authenticator>
  )
}


export const AuthenticatorProvider = (props) => {

  return (
    <ThemeProvider
      theme={{
        tokens: {
          colors: {
            primary: {
              10: '{colors.orange.10}',
              20: '{colors.orange.20}',
              40: '{colors.orange.40}',
              60: '{colors.orange.60}',
              80: '#ff6600',
              90: '{colors.orange.90}',
              100: '{colors.orange.100}',
            },
          },
        },
      }}
    >
      <Authenticator.Provider>
        <AuthenticatorComponent {...props} />
      </Authenticator.Provider>
    </ThemeProvider>
  )
}